export interface PositionLevel {
  z: number;
  name: string;
}

export type PositionLevelsMap = Map<string, PositionLevel[]>;

export function buildPositionLevelsMap(positions: Array<{ x: number; y: number; z: number; levelName?: string }>): PositionLevelsMap {
  const map: PositionLevelsMap = new Map();
  for (const pos of positions) {
    const key = `${pos.x}_${pos.y}`;
    const value: PositionLevel = { z: pos.z, name: pos.levelName };
    if (!map.has(key)) {
      map.set(key, [value]);
    } else {
      map.get(key).push(value);
    }
  }
  for (const [key, levels] of map.entries()) {
    levels.sort((a, b) => a.z - b.z);
  }
  return map;
}

export function getPositionLevels(position: { x: number; y: number }, map: PositionLevelsMap): PositionLevel[] {
  if (!position) { return []; }
  const key = `${position.x}_${position.y}`;
  return map.get(key) || [];
}
